var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import WindowConfigContext from '../../context/window-config-context';
import WindowReadonlyContext from '../../context/window-readonly-context';
import WindowStateContext from '../../context/window-state-context';
import { blinkingAnimation, getGeometryStyle, getHeightWidth, getMaximumHeight, getMaximumWidth, getMinimumHeight, getMinimumWidth, updateStylesheet, } from '../../helpers/styles';
import { isTrue } from '../../helpers/utils';
import useAnimatedTextItem from '../../hooks/useAnimatedTextItem';
import useFocusableItem from '../../hooks/useFocusableItem';
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
var getMaxHeightWidth = function (maximumSize) {
    return "\n  max-height: " + getMaximumHeight(maximumSize) + ";\n  max-width: " + getMaximumWidth(maximumSize) + ";";
};
export var StyledTextInput = styled.input.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  background: ", ";\n  background-color: ", ";\n  outline: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-family: ", ";\n  ", ";\n  ", ";\n  ", "\n  cursor: ", ";\n  ", "\n  :focus {\n    border-color: ", ";\n  }\n\n  ", "\n"], ["\n  ", "\n  color: ",
    ";\n  background: ", ";\n  background-color: ",
    ";\n  outline: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-family: ", ";\n  ",
    ";\n  ", ";\n  ", "\n  cursor: ", ";\n  ",
    "\n  :focus {\n    border-color: ",
    ";\n  }\n\n  ",
    "\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme, fontColor = _a.fontColor;
    return fontColor ? fontColor + " !important" : windowTheme.textInput.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.background;
}, function (_a) {
    var windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor;
    return backgroundColor
        ? "" + backgroundColor
        : windowTheme.textInput.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.paddingLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.paddingRight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.fontFamily;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getHeightWidth(windowTheme.textInput.width, windowTheme.textInput.height);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return maximumSize && getMaxHeightWidth(maximumSize);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var readOnly = _a.readOnly;
    return (readOnly ? 'not-allowed' : 'auto');
}, function (_a) {
    var attributes = _a.attributes, type = _a.type;
    return attributes &&
        attributes.styleSheet &&
        updateStylesheet(attributes.styleSheet._, type);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textInput.focus.borderColor;
}, function (_a) {
    var windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor, blinkingTime = _a.blinkingTime;
    return backgroundColor &&
        blinkingTime && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      animation: ", "\n        ", "s infinite;\n    "], ["\n      animation: ",
        "\n        ", "s infinite;\n    "])), blinkingAnimation(backgroundColor, windowTheme.textInput.backgroundColor), blinkingTime);
});
function TextInput(props) {
    var identifier = props.identifier, attributes = props.attributes, form = props.form, _a = props.type, type = _a === void 0 ? 'text' : _a, onChange = props.onChange, children = props.children, windowId = props.windowId, restProps = __rest(props, ["identifier", "attributes", "form", "type", "onChange", "children", "windowId"]);
    console.log('===props==', props);
    var overWriteReadOnly = useContext(WindowReadonlyContext);
    var stateFromEnv = useContext(WindowStateContext);
    var config = useContext(WindowConfigContext);
    var valuesFromEnv = stateFromEnv.fields;
    var fontColor = valuesFromEnv[identifier + "_fontColor"];
    var backgroundColor = valuesFromEnv[identifier + "_backgroundColor"];
    var blinkingTime = valuesFromEnv[identifier + "_blinkingTime"];
    var enabled = attributes.enabled, readOnly = attributes.readOnly, maxLength = attributes.maxLength, minumumSize = attributes.minumumSize, maximumSize = attributes.maximumSize, otherAttributes = __rest(attributes, ["enabled", "readOnly", "maxLength", "minumumSize", "maximumSize"]);
    var disabled = enabled === 'false';
    var _b = useAnimatedTextItem(identifier), setValue = _b.setValue, hookProps = __rest(_b, ["setValue"]);
    var focusProps = useFocusableItem(windowId, identifier, setValue);
    return (React.createElement(StyledTextInput, __assign({ type: type, id: identifier, maxLength: config.isBuilder ? 100 : maxLength }, restProps, otherAttributes, { attributes: attributes, disabled: !overWriteReadOnly && disabled, readOnly: !overWriteReadOnly && isTrue(readOnly) }, hookProps, focusProps, { fontColor: fontColor, backgroundColor: backgroundColor, minumumSize: minumumSize, maximumSize: maximumSize, blinkingTime: blinkingTime })));
}
export default TextInput;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map